import m from "../../es2015/lang/de_DE";
window.am4lang_de_DE = m;


//////////////////
// WEBPACK FOOTER
// ./lang/de_DE.js
// module id = null
// module chunks = 